<template>
  <tr class="table-fee-breakdown__row">
    <td class="table-fee-breakdown__code">{{ item.relationship.code }}</td>
    <td class="table-fee-breakdown__name">{{ item.relationship.name }}</td>
    <td class="table-fee-breakdown__credits">Credits: {{ item.relationship.credits }}</td>
    <td class="table-fee-breakdown__cost">{{ fees }}</td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import Formatter from '../../../common/helpers/formatter'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    seenUnits: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      duplicate: false
    }
  },
  computed: {
    ...mapGetters({
      completedUnits: 'units/getCompletedUnits',
      feesPreferences: 'preferences/getFeesPreferences',
      feesLoaded: 'preferences/getFeesLoaded',
    }),
    completed() {
      return this.completedUnits.includes(this.item.relationship.code)
    },
    fees() {
      if (this.completed)
        return "Completed"
      if (this.duplicate)
        return "Duplicate"

      return this.feesLoaded
        ? Formatter.FormatCurrency(this.feesPreferences.calculator.calculate(this.item.relationship.unit))
        : null
    }
  },
  methods: {},
  mounted() {
      if (this.seenUnits.indexOf(this.item.id) > 0)
        this.duplicate = true

      this.seenUnits.push(this.item.id)
  },
  components: {}
}
</script>
